import { Placeholder } from "react-bootstrap"

export const SkeletonFeedRanking = () => {
    return (
        <Placeholder as="div" animation="glow">
            <Placeholder xs={7} className="me-3" /> <Placeholder xs={4} />
        </Placeholder>
    )
}